import React from 'react';
import Typography from '@mui/material/Typography';
import type { DiagnosisContinuation } from '../../apis';

export default function ContinuationNote({ continuation }: { continuation?: DiagnosisContinuation }) {
  if (!continuation) return null;
  return (
    <Typography variant="body2" sx={{ color: 'text.secondary', p: 1, borderRadius: '8px', bgcolor: 'var(--agent-tint)', border: '1px solid var(--line-soft)' }} data-testid="continuation-provenance">
      Historical measurements: reused {continuation.reused_queries} saved query result(s) from {continuation.measurements_recorded_at}.
      {' '}Saved measurements were not refreshed; only newly explored queries were run.
    </Typography>
  );
}
